import {
    Avatar,
    Card,
    CardActionArea,
    styled,
    Typography,
} from "@mui/material";
import FolderIcon from "@mui/icons-material/Folder";

interface Props {
    name: string;
    onClick: () => void;
    logoUrl?: string;
}

function FolderCard({ name, onClick, logoUrl }: Props): JSX.Element {
    return (
        <CardContainer>
            <CardActionArea
                onClick={onClick}
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "0.5rem",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    height: "100%",
                    padding: "1rem",
                }}
            >
                <Avatar
                    src={logoUrl ? logoUrl : undefined}
                    sx={{
                        width: 40,
                        height: 40,
                        backgroundColor: "#e53835",
                        fontSize: 20,
                    }}
                >
                    {!logoUrl && <FolderIcon sx={{ color: "#fff" }} />}
                </Avatar>
                <Typography variant="subtitle1" fontWeight={600}>
                    {name}
                </Typography>
            </CardActionArea>
        </CardContainer>
    );
}

export default FolderCard;

const CardContainer = styled(Card)(({ theme }) => ({
    width: "100%",
    maxWidth: 320,
    minHeight: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F0F4F8",
    borderRadius: "10px",
    transition: "all 0.2s ease-in-out",
    cursor: "pointer",
    "&:hover": {
        transform: "scale(1.01)",
        boxShadow: theme.shadows[2],
    },
}));
